import { phoneVerify } from '../../../constant/formRegular.js'

const idCardReg = /^[1-9]\d{5}(19|20)\d{2}(0\d|1[0-2])([0-2]\d|3[0-1])\d{3}[0-9Xx]$/

export const OPERATE_TYPES = {
    ADD: 'ADD', // 新增
    EDIT: 'EDIT', // 编辑
    AUDIT: 'AUDIT', // 审批
}

// 仓储委派函类型 WAREHOUSE_DELEGATE_TYPE
export const DELEGATE_TYPES = {
    ONLINE: '1',
    OFFLINE: '2',
}

// 操作表单初始值
export const INIT_FORM = {
    id: null,
    physicalWarehouseCode: null,
    logicalWarehouseName: null,
    logicalWarehouseCode: null,
    warehouseDelegateNo: null,
    legalContractCode: null,
    contractCode: null,
    contractName: null,
    supplierCode: null,
    supplierName: null,
    workerType: null,
    idCardFrontFileId: null,
    idCardFrontFileUrl: null,
    idCardFrontFileName: null,
    idCardVersoFileId: null,
    idCardVersoFileUrl: null,
    idCardVersoFileName: null,
    workerName: null,
    idCardNo: null,
    effectStartDate: null,
    effectEndDate: null,
    workerPhone: null,
    delegateType: DELEGATE_TYPES.ONLINE,
    signerCode: null,
    signerName: null,
    signerPhone: null,
    delegateStartTime: null,
    delegateEndTime: null,
    warehouseDelegateFlieList: [],
    physicalWarehouseName: '',
    approverList: [],
    siteCode: '',
    mainLogicalWarehouseName: '',
    mainLogicalWarehouseCode: '',
    // legalContractCode: null,
    salaryPaydayCode: null,
}

// 操作表单校验规则
export const RULES = {
    legalContractCode: [{ required: true, message: '请选择法务合同号', trigger: ['change'] }],
    workerType: [{ required: true, message: '请选择仓库人员类型', trigger: ['change'] }],
    mainLogicalWarehouseName: [{ required: true, message: '请选择主工作逻辑仓', trigger: ['change'] }],
    workerName: [
        { required: true, message: '请输入姓名', trigger: ['change'] },
        { max: 30, message: '最多输入30个字符', trigger: ['change'] }
    ],
    idCardNo: [
        { required: true, message: '请输入身份证号', trigger: ['change'] },
        { pattern: idCardReg, message: '请输入正确格式的身份证', trigger: ['blur', 'change'] }
    ],
    effectStartDate: [{ required: true, message: '请选择身份证起始期', trigger: ['change'] }],
    effectEndDate: [{ required: true, message: '请选择身份证有效期', trigger: ['change'] }],
    workerPhone: [
        { required: true, message: '请输入手机号码', trigger: ['change'] },
        { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: ['blur', 'change'] },
    ],
    delegateType: [{ required: true, message: '请选择委派函类型', trigger: ['change'] }],
    signerName: [{ required: true, message: '请选择签署人', trigger: ['change'] }],
    signerPhone: [{ required: true, message: '请输入签署人手机号', trigger: ['change'] }],
    // delegateStartTime: [{ required: true, message: '请选择委派开始时间', trigger: ['change'] }],
    delegateEndTime: [{ required: true, message: '请选择委派结束时间', trigger: ['change'] }],
    warehouseDelegateFlieList: [{ required: true, message: '请上传纸质委派函', trigger: ['change'] }],
    approverList: [
    { validator: (rule, value, callback) => {
        if (value.length > 20) {
          callback(new Error('审批人最多20人'));
        }  else {
          callback();
        }
      }, trigger: ['blur', 'change'] }],
    // property: [
    //     { required: true, message: '请选择主体性质', trigger: ['change'] }
    // ],
    // driverNumber: [
    //     { pattern: positiveIntegerVerify, message: '司机数量必须为正整数', trigger: 'blur' }
    // ],
    // vehiclesNumber: [
    //     { pattern: positiveIntegerVerify, message: '车辆数量必须为正整数', trigger: 'blur' }
    // ]
}

// 身份证起始期可选日期
export const startPickerOptions = {
    disabledDate: time => {
        const now = new Date()
        now.setHours(23)
        now.setMinutes(59)
        now.setSeconds(59)
        now.setMilliseconds(0)
        return (time.getTime() > now.getTime());
    }
}

// 身份证有效期可选日期
export const endPickerOptions = {
    disabledDate: time => {
        const now = new Date()
        now.setHours(0)
        now.setMinutes(0)
        now.setSeconds(0)
        now.setMilliseconds(0)
        return (time.getTime() < now.getTime());
    }
}

// 合同分页查询
export const contractConfig = {
    name: '合同单据编码',
    value: 'legalContractCode',
    dialogWidth: '1200px',
    method: 'post',
    // unfold: true,
    advanceConfig: [
        { prop: 'contractCode', value: '合同单据编码' },
        { prop: 'legalContractCode', value: '法务合同号' },
        { prop: 'contractName', value: '合同名称' },
    ],
    
    moreSearchList: [
        {
            prop: 'contractCode',
            label: '合同单据编码',
            type: 'input'
        },
        {
            prop: 'legalContractCode',
            label: '法务合同号',
            type: 'input'
        },
        {
            prop: 'contractName',
            label: '合同名称',
            type: 'input'
        },
    ],
    tableConfig: [
        { prop: 'contractCode', value: '合同单据编码', width: '150px' },
        { prop: 'legalContractCode', value: '法务合同号', width: '140px' },
        { prop: 'contractName', value: '合同名称', width: '150px' },
        { prop: 'contractStatus', value: '合同状态', width: '80px', type: 'select', optionsKey: 'SRM_CONTRACT_STATUS', options: [] },
        { prop: 'businessType', value: '业务类型', width: '80px', type: 'select', optionsKey: 'SRM_BUSYNESS_TYPE_BACKGROUND', options: [] },
        { prop: 'companyName', value: '分公司' },
        { prop: 'siteName', value: '服务平台' },
        { prop: 'physicalWarehouseName', value: '物理仓' },
        { prop: 'logicalWarehouseName', value: '逻辑仓' },
    ],
    advanceUrl: '/contract/warehouseContractPage',
    advanceCascade: 'supplierCode',
    type: 'advance',
    prefix: '/api-srm-web',
    cbParams: ['contractCode', 'legalContractCode', 'contractName', 'supplierCode', 'supplierName', 'expirationDate', 'physicalWarehouseName', 'siteCode']
}

// 主工作逻辑仓分页查询
export const logicalWarehouseParams = {
    name: '主工作逻辑仓',
    value: 'cdwhName',
    type: 'advance',
    advanceLabel: '逻辑仓弹出框',
    advanceConfig: [
        { prop: 'cdwhName', value: '逻辑仓名称' },
        { prop: 'whCode', value: '逻辑仓编码' }
    ],
    tableConfig: [
        { prop: 'whCode', value: '逻辑仓编码' },
        { prop: 'cdwhName', value: '名称' },
    ],
    advanceUrl: '/public/api/searchCdWarehouse',
    prefix: '/api-srm',
    method: 'get',
    cbParams: ['cdwhName#mainLogicalWarehouseName', 'whCode#mainLogicalWarehouseCode'],
}

// 操作弹窗标题
export const OPERATE_TITLES = {
    ADD: '仓库人员新增',
    EDIT: '仓库人员编辑',
    AUDIT: '审批详情',
}

// WAREHOUSE_DELEGATE_AUDIT_STATUS
export const AUDIT_STATUS = {
    DRAFT: '00', // 草稿
    NEW: '01', // 新建
    WAIT: '2', // 待审批
    PENDING: '3', // 审批中
    ADOPT: '20', // 通过
    REJECT: '30', // 驳回
    DISCARD: '40', //废弃
    WITHDRAW: '80', // 撤回
}
